import { passengerTypes } from 'types/passengers';
import { reduceBy, values, pipe, path } from 'ramda';

const getTariffCode = path(['tariffDetails', 'tariffCode']);

const combineBookingItems = (acc, bookingItem) => ({
  name: bookingItem.name,
  passengerType: passengerTypes[bookingItem.passenger.type],
  code: getTariffCode(bookingItem),
  total: acc.total ? acc.total + bookingItem.price : bookingItem.price,
  quantity: acc.quantity ? acc.quantity + 1 : 1,
  price: bookingItem.price,
  currency: bookingItem.currency
});

const groupByTariffCode = pipe(reduceBy(combineBookingItems, {}, getTariffCode), values);

export default groupByTariffCode;
